(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eagle-x-video-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eaglex-video-tabs-v1')) {
    customElements.define('eaglex-video-tabs-v1', class extends HTMLElement {
      connectedCallback() {
        this._frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected || this._abort) return;
        this._tabs = Array.from(this.querySelectorAll('[data-exv-tab]'));
        this._stage = this.querySelector('.exv-stage');
        this._error = this.querySelector('.exv-error');
        if (!this._stage || this._tabs.length !== 4) return;
        this._abort = new AbortController();
        const options = { signal: this._abort.signal };
        this._tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, true), options);
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % 4;
            else if (event.key === 'ArrowLeft') next = (index + 3) % 4;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = 3;
            else return;
            event.preventDefault();
            this._tabs[next].focus({ preventScroll: true });
            this.select(next, false);
          }, options);
        });
        this.watchVideo();
        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) this._stage.querySelector('video')?.pause();
          });
          this._observer.observe(this);
        }
      }
      watchVideo() {
        this._mediaAbort?.abort();
        this._mediaAbort = new AbortController();
        const video = this._stage.querySelector('video');
        if (!video) return;
        video.addEventListener('error', () => { this._error.hidden = false; }, { signal: this._mediaAbort.signal });
      }
      select(index, userClick) {
        const tab = this._tabs[index];
        const template = this.querySelector('[data-exv-template="' + (index + 1) + '"]');
        if (!tab || !template) return;
        this._stage.querySelector('video')?.pause();
        this._error.hidden = true;
        this._stage.replaceChildren(template.content.cloneNode(true));
        this._tabs.forEach((item, i) => {
          item.setAttribute('aria-selected', String(i === index));
          item.tabIndex = i === index ? 0 : -1;
        });
        this._stage.setAttribute('aria-labelledby', tab.id);
        this.watchVideo();
        const video = this._stage.querySelector('video');
        if (video && userClick && this.dataset.playOnSwitch === 'true') {
          video.muted = true;
          const attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this._frame);
        this._abort?.abort();
        this._mediaAbort?.abort();
        this._observer?.disconnect();
        this.querySelector('.exv-stage video')?.pause();
        this._abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-01-assembly"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ex-tail-assembly'))customElements.define('ex-tail-assembly',class extends HTMLElement{
 connectedCallback(){this._frame=requestAnimationFrame(()=>{if(this._abort||!this.isConnected)return;this._abort=new AbortController();const opt={signal:this._abort.signal};this.tabs=[...this.querySelectorAll('[data-assembly-tab]')];this.stage=this.querySelector('.ext-assembly-stage');this.tabs.forEach((b,i)=>{b.addEventListener('click',()=>this.select(i,true),opt);b.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%4;else if(e.key==='ArrowLeft')n=(i+3)%4;else if(e.key==='Home')n=0;else if(e.key==='End')n=3;else return;e.preventDefault();this.tabs[n].focus({preventScroll:true});this.select(n,false);},opt);});if('IntersectionObserver' in window){this.observer=new IntersectionObserver(es=>{if(!es[0].isIntersecting)this.stage.querySelector('video')?.pause();});this.observer.observe(this);}});}
 select(i,play){const template=this.querySelector('[data-assembly-template="'+(i+1)+'"]');if(!template)return;this.stage.querySelector('video')?.pause();this.stage.replaceChildren(template.content.cloneNode(true));this.tabs.forEach((b,j)=>{b.setAttribute('aria-selected',String(i===j));b.tabIndex=i===j?0:-1;});this.stage.setAttribute('aria-labelledby',this.tabs[i].id);const v=this.stage.querySelector('video');if(v&&play&&this.dataset.playOnSwitch==='true'){v.muted=true;const p=v.play();if(p&&p.catch)p.catch(()=>{});}}
 disconnectedCallback(){cancelAnimationFrame(this._frame);this.querySelector('.ext-assembly-stage video')?.pause();this._abort?.abort();this.observer?.disconnect();this._abort=null;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-02-materials"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ex-tail-modal'))customElements.define('ex-tail-modal',class extends HTMLElement{
 connectedCallback(){this._frame=requestAnimationFrame(()=>this.init());}
 init(){if(this._abort||!this.isConnected)return;this.dialog=this.querySelector('.ext-dialog');if(!this.dialog)return;this._abort=new AbortController();const opt={signal:this._abort.signal};
 this.addEventListener('click',e=>{const opener=e.target.closest('[data-ext-play]');if(opener&&this.contains(opener)){const template=this.querySelector('[data-ext-template="'+opener.dataset.extPlay+'"]');if(!template)return;document.querySelectorAll('ex-tail-modal dialog[open]').forEach(d=>d.close());this.opener=opener;this.querySelector('[data-ext-dialog-title]').textContent=opener.dataset.extTitle||'EAGLE X';this.querySelector('[data-ext-dialog-player]').replaceChildren(template.content.cloneNode(true));this.dialog.showModal();const player=this.dialog.querySelector('video');if(player){const p=player.play();if(p&&p.catch)p.catch(()=>{});}}if(e.target.closest('[data-ext-close]')||e.target===this.dialog)this.dialog.close();},opt);
 this.dialog.addEventListener('close',()=>{this.dialog.querySelector('video')?.pause();this.querySelector('[data-ext-dialog-player]').replaceChildren();if(this.opener?.isConnected)this.opener.focus({preventScroll:true});},opt);
 }
 disconnectedCallback(){cancelAnimationFrame(this._frame);this.dialog?.querySelector('video')?.pause();if(this.dialog?.open)this.dialog.close();this._abort?.abort();this._abort=null;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-03-diy"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ex-tail-modal'))customElements.define('ex-tail-modal',class extends HTMLElement{
 connectedCallback(){this._frame=requestAnimationFrame(()=>this.init());}
 init(){if(this._abort||!this.isConnected)return;this.dialog=this.querySelector('.ext-dialog');if(!this.dialog)return;this._abort=new AbortController();const opt={signal:this._abort.signal};
 this.addEventListener('click',e=>{const opener=e.target.closest('[data-ext-play]');if(opener&&this.contains(opener)){const template=this.querySelector('[data-ext-template="'+opener.dataset.extPlay+'"]');if(!template)return;document.querySelectorAll('ex-tail-modal dialog[open]').forEach(d=>d.close());this.opener=opener;this.querySelector('[data-ext-dialog-title]').textContent=opener.dataset.extTitle||'EAGLE X';this.querySelector('[data-ext-dialog-player]').replaceChildren(template.content.cloneNode(true));this.dialog.showModal();const player=this.dialog.querySelector('video');if(player){const p=player.play();if(p&&p.catch)p.catch(()=>{});}}if(e.target.closest('[data-ext-close]')||e.target===this.dialog)this.dialog.close();},opt);
 this.dialog.addEventListener('close',()=>{this.dialog.querySelector('video')?.pause();this.querySelector('[data-ext-dialog-player]').replaceChildren();if(this.opener?.isConnected)this.opener.focus({preventScroll:true});},opt);
 }
 disconnectedCallback(){cancelAnimationFrame(this._frame);this.dialog?.querySelector('video')?.pause();if(this.dialog?.open)this.dialog.close();this._abort?.abort();this._abort=null;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-05-field-videos"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ex-tail-modal'))customElements.define('ex-tail-modal',class extends HTMLElement{
 connectedCallback(){this._frame=requestAnimationFrame(()=>this.init());}
 init(){if(this._abort||!this.isConnected)return;this.dialog=this.querySelector('.ext-dialog');if(!this.dialog)return;this._abort=new AbortController();const opt={signal:this._abort.signal};
 this.addEventListener('click',e=>{const opener=e.target.closest('[data-ext-play]');if(opener&&this.contains(opener)){const template=this.querySelector('[data-ext-template="'+opener.dataset.extPlay+'"]');if(!template)return;document.querySelectorAll('ex-tail-modal dialog[open]').forEach(d=>d.close());this.opener=opener;this.querySelector('[data-ext-dialog-title]').textContent=opener.dataset.extTitle||'EAGLE X';this.querySelector('[data-ext-dialog-player]').replaceChildren(template.content.cloneNode(true));this.dialog.showModal();const player=this.dialog.querySelector('video');if(player){const p=player.play();if(p&&p.catch)p.catch(()=>{});}}if(e.target.closest('[data-ext-close]')||e.target===this.dialog)this.dialog.close();},opt);
 this.dialog.addEventListener('close',()=>{this.dialog.querySelector('video')?.pause();this.querySelector('[data-ext-dialog-player]').replaceChildren();if(this.opener?.isConnected)this.opener.focus({preventScroll:true});},opt);
 }
 disconnectedCallback(){cancelAnimationFrame(this._frame);this.dialog?.querySelector('video')?.pause();if(this.dialog?.open)this.dialog.close();this._abort?.abort();this._abort=null;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-08-reserve"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ex-tail-reserve'))customElements.define('ex-tail-reserve',class extends HTMLElement{
 connectedCallback(){this._frame=requestAnimationFrame(()=>{if(this._abort||!this.isConnected)return;this._abort=new AbortController();const opt={signal:this._abort.signal};this.querySelectorAll('[data-ext-color]').forEach(button=>button.addEventListener('click',()=>{this.querySelectorAll('[data-ext-color]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));const image=this.querySelector('[data-ext-color-image]');image.src=button.dataset.image;image.alt=button.dataset.label+' EAGLE X and RC controller';this.querySelector('[data-ext-sku]').textContent=button.dataset.sku;},opt));});}
 disconnectedCallback(){cancelAnimationFrame(this._frame);this._abort?.abort();this._abort=null;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-factory"] && !Shopify.designMode) return;
  try {
    

if (!window.__eaglexMediaCoordinator) {
 window.__eaglexMediaCoordinator = true;
 document.addEventListener('play', event => {
  const video = event.target;
  if (video.tagName !== 'VIDEO' || !video.closest('.exhv,.exqf,.exfs,.exmf,.ext-section,.exfw,.exdt')) return;
  document.querySelectorAll('.exhv video,.exqf video,.exfs video,.exmf video,.ext-section video,.exfw video,.exdt video').forEach(other => { if (other !== video) other.pause(); });
 }, true);
 document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('.exhv video,.exqf video,.exfs video,.exmf video,.ext-section video,.exfw video,.exdt video').forEach(v => v.pause()); });
 document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('video').forEach(v => v.pause()));
 document.addEventListener('toggle', event => { if (event.target.matches('.exfs-secondary') && !event.target.open) event.target.querySelectorAll('video').forEach(v => v.pause()); }, true);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-flight-system"] && !Shopify.designMode) return;
  try {
    

if (!window.__eaglexMediaCoordinator) {
 window.__eaglexMediaCoordinator = true;
 document.addEventListener('play', event => {
  const video = event.target;
  if (video.tagName !== 'VIDEO' || !video.closest('.exhv,.exqf,.exfs,.exmf,.ext-section,.exfw,.exdt')) return;
  document.querySelectorAll('.exhv video,.exqf video,.exfs video,.exmf video,.ext-section video,.exfw video,.exdt video').forEach(other => { if (other !== video) other.pause(); });
 }, true);
 document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('.exhv video,.exqf video,.exfs video,.exmf video,.ext-section video,.exfw video,.exdt video').forEach(v => v.pause()); });
 document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('video').forEach(v => v.pause()));
 document.addEventListener('toggle', event => { if (event.target.matches('.exfs-secondary') && !event.target.open) event.target.querySelectorAll('video').forEach(v => v.pause()); }, true);
}


if (!customElements.get('eaglex-flight-player-v1')) {
  customElements.define('eaglex-flight-player-v1', class extends HTMLElement {
    connectedCallback() {
      this._frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (this._abort || !this.isConnected) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-exfs-play]');
      this.poster = this.querySelector('[data-exfs-poster]');
      this.error = this.querySelector('[data-exfs-error]');
      if (!this.video || !this.button) return;
      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      this._sourceErrors = new Set();
      this._failed = false;
      this.setAttribute('data-enhanced', '');
      this.video.controls = false;
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.error.hidden = true;
        this.button.hidden = true;
        if (this.poster) this.poster.hidden = true;
        this.video.controls = true;
        this.video.focus({ preventScroll: true });
        if (this._failed || this.video.error) this.video.load();
        this._failed = false;
        this._sourceErrors.clear();
        let attempt;
        try { attempt = this.video.play(); } catch (error) { attempt = Promise.reject(error); }
        Promise.resolve(attempt).catch(error => {
          if (!this.isConnected || error?.name === 'AbortError') return;
          this.button.hidden = false;
          if (this.poster) this.poster.hidden = false;
          if (error?.name !== 'NotAllowedError') this.showError();
        });
      }, options);
      this.video.addEventListener('play', () => {
        this.button.hidden = true;
        if (this.poster) this.poster.hidden = true;
        document.querySelectorAll('eaglex-flight-player-v1, eaglex-intro-film-v1').forEach(player => {
          if (player !== this) player.querySelector('video')?.pause();
        });
      }, options);
      this.video.addEventListener('ended', () => {
        this.button.hidden = false;
        this.video.controls = false;
        if (this.poster) this.poster.hidden = false;
      }, options);
      this.video.addEventListener('error', event => {
        if (event.target === this.video) this.showError();
        else if (event.target.tagName === 'SOURCE') {
          this._sourceErrors.add(event.target);
          if (this._sourceErrors.size >= this.video.querySelectorAll('source').length) this.showError();
        }
      }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
      }, options);
      if ('IntersectionObserver' in window && this.dataset.pauseOffscreen === 'true') {
        this._observer = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting && !this.contains(document.fullscreenElement) && !this.video.webkitDisplayingFullscreen) this.video.pause();
        }, { threshold: 0 });
        this._observer.observe(this);
      }
    }
    showError() {
      this._failed = true;
      this.error.hidden = false;
      this.button.hidden = false;
      this.video.controls = true;
      if (this.poster) this.poster.hidden = false;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      this._observer?.disconnect();
      this._abort?.abort();
      this._abort = null;
      this.video?.pause();
      if (this.video) this.video.controls = true;
      if (this.button) this.button.hidden = true;
      this.removeAttribute('data-enhanced');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-hero-video"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('eaglex-ambient-v2')) {
  customElements.define('eaglex-ambient-v2', class extends HTMLElement {
    connectedCallback() {
      this._frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (this._abort || !this.isConnected) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-ambient-toggle]');
      if (!this.video || !this.button) return;
      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      this._userPaused = false;
      this._manualPlay = false;
      this._blocked = false;
      this._failed = false;
      this._pending = false;
      this._sequence = (this._sequence || 0) + 1;
      this._inView = !('IntersectionObserver' in window);
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.controls = false;
      this.button.hidden = false;
      this.reflect();
      this.button.addEventListener('click', () => {
        if (!this.video.paused || this._pending) {
          this._userPaused = true;
          this._manualPlay = false;
        } else {
          this._userPaused = false;
          this._manualPlay = true;
          this._blocked = false;
        }
        this.sync();
      }, options);
      this.video.addEventListener('play', () => {
        if (!this.shouldPlay()) this.video.pause();
        this.reflect();
      }, options);
      this.video.addEventListener('pause', () => this.reflect(), options);
      this.video.addEventListener('error', (event) => {
        if (event.target !== this.video && !this.video.error) return;
        this._failed = true;
        this.video.hidden = true;
        this.button.hidden = true;
        this.sync();
      }, { ...options, capture: true });
      this._motionChanged = () => {
        this._manualPlay = false;
        this.sync();
      };
      this._motion.addEventListener('change', this._motionChanged);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this._observer.observe(this);
      }
      this.sync();
    }
    shouldPlay() {
      return this.isConnected && this._inView && !document.hidden && !this._failed && !this._blocked && !this._userPaused && (!this._motion.matches || this._manualPlay);
    }
    sync() {
      if (!this.video) return;
      if (!this.shouldPlay()) {
        this._sequence += 1;
        this._pending = false;
        this.video.pause();
        this.reflect();
        return;
      }
      if (!this.video.paused || this._pending) return;
      this._pending = true;
      const sequence = ++this._sequence;
      let attempt;
      try { attempt = this.video.play(); } catch (error) { attempt = Promise.reject(error); }
      Promise.resolve(attempt).then(() => {
        if (sequence !== this._sequence) return;
        this._pending = false;
        if (!this.shouldPlay()) this.video.pause();
        this.reflect();
      }).catch(() => {
        if (sequence !== this._sequence) return;
        this._pending = false;
        this._blocked = true;
        this.reflect();
      });
    }
    reflect() {
      if (!this.button || !this.video) return;
      this.button.textContent = this.video.paused ? '▶' : 'Ⅱ';
      this.button.setAttribute('aria-label', this.video.paused ? 'Play background video' : 'Pause background video');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      this._sequence += 1;
      this._observer?.disconnect();
      this._motion?.removeEventListener('change', this._motionChanged);
      this._abort?.abort();
      this._abort = null;
      this.video?.pause();
      if (this.button) this.button.hidden = true;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-intro-video"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('eaglex-intro-film-v1')) {
  customElements.define('eaglex-intro-film-v1', class extends HTMLElement {
    connectedCallback() {
      this._frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (this._abort || !this.isConnected) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-exmf-play]');
      this.error = this.querySelector('[data-exmf-error]');
      if (!this.video || !this.button) return;
      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      this.video.controls = false;
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.error.hidden = true;
        this.button.hidden = true;
        this.video.controls = true;
        this.video.focus({ preventScroll: true });
        if (this.video.ended) this.video.currentTime = 0;
        const playback = this.video.play();
        if (playback && playback.catch) playback.catch(error => {
          if (!this.isConnected) return;
          this.video.controls = true;
          if (error.name === 'NotSupportedError' || this.video.error) this.error.hidden = false;
        });
      }, options);
      this.video.addEventListener('play', () => {
        this.button.hidden = true;
        this.video.controls = true;
        this.error.hidden = true;
        document.querySelectorAll('eaglex-intro-film-v1 video').forEach(other => {
          if (other !== this.video) other.pause();
        });
      }, options);
      this.video.addEventListener('ended', () => {
        this.button.hidden = false;
        this.video.controls = false;
      }, options);
      this.video.addEventListener('error', () => {
        this.button.hidden = true;
        this.video.controls = true;
        this.error.hidden = false;
      }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
      }, options);
      if (this.dataset.pauseOffscreen === 'true' && 'IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          const fullscreen = document.fullscreenElement === this.video || this.video.webkitDisplayingFullscreen;
          if (!entries[0].isIntersecting && !fullscreen) this.video.pause();
        }, { threshold: 0 });
        this._observer.observe(this.querySelector('.exmf-stage'));
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      if (this.video) { this.video.pause(); this.video.controls = true; }
      if (this.button) this.button.hidden = true;
      this._observer?.disconnect();
      this._abort?.abort();
      this._abort = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglex-quiet-flight"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('eaglex-ambient-v2')) {
  customElements.define('eaglex-ambient-v2', class extends HTMLElement {
    connectedCallback() {
      this._frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (this._abort || !this.isConnected) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-ambient-toggle]');
      if (!this.video || !this.button) return;
      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      this._userPaused = false;
      this._manualPlay = false;
      this._blocked = false;
      this._failed = false;
      this._pending = false;
      this._sequence = (this._sequence || 0) + 1;
      this._inView = !('IntersectionObserver' in window);
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.controls = false;
      this.button.hidden = false;
      this.reflect();
      this.button.addEventListener('click', () => {
        if (!this.video.paused || this._pending) {
          this._userPaused = true;
          this._manualPlay = false;
        } else {
          this._userPaused = false;
          this._manualPlay = true;
          this._blocked = false;
        }
        this.sync();
      }, options);
      this.video.addEventListener('play', () => {
        if (!this.shouldPlay()) this.video.pause();
        this.reflect();
      }, options);
      this.video.addEventListener('pause', () => this.reflect(), options);
      this.video.addEventListener('error', (event) => {
        if (event.target !== this.video && !this.video.error) return;
        this._failed = true;
        this.video.hidden = true;
        this.button.hidden = true;
        this.sync();
      }, { ...options, capture: true });
      this._motionChanged = () => {
        this._manualPlay = false;
        this.sync();
      };
      this._motion.addEventListener('change', this._motionChanged);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this._observer.observe(this);
      }
      this.sync();
    }
    shouldPlay() {
      return this.isConnected && this._inView && !document.hidden && !this._failed && !this._blocked && !this._userPaused && (!this._motion.matches || this._manualPlay);
    }
    sync() {
      if (!this.video) return;
      if (!this.shouldPlay()) {
        this._sequence += 1;
        this._pending = false;
        this.video.pause();
        this.reflect();
        return;
      }
      if (!this.video.paused || this._pending) return;
      this._pending = true;
      const sequence = ++this._sequence;
      let attempt;
      try { attempt = this.video.play(); } catch (error) { attempt = Promise.reject(error); }
      Promise.resolve(attempt).then(() => {
        if (sequence !== this._sequence) return;
        this._pending = false;
        if (!this.shouldPlay()) this.video.pause();
        this.reflect();
      }).catch(() => {
        if (sequence !== this._sequence) return;
        this._pending = false;
        this._blocked = true;
        this.reflect();
      });
    }
    reflect() {
      if (!this.button || !this.video) return;
      this.button.textContent = this.video.paused ? '▶' : 'Ⅱ';
      this.button.setAttribute('aria-label', this.video.paused ? 'Play background video' : 'Pause background video');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      this._sequence += 1;
      this._observer?.disconnect();
      this._motion?.removeEventListener('change', this._motionChanged);
      this._abort?.abort();
      this._abort = null;
      this.video?.pause();
      if (this.button) this.button.hidden = true;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
